<div *ngIf="role">
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-12 panel-title">
          <span class="h4">{{ role.name }}</span>
          <close-button></close-button>
          <a [routerLink]="['edit']" class="btn btn-outline-secondary float-end">
            <mat-icon>edit</mat-icon>
          </a>
        </div>
      </div>
    </div>
    <div class="card-body" style="font-size: 20px">{{ role.description }}</div>
  </div>
  <br />
  <div class="row">
    <div class="col-md-6">
      <div class="card">
        <div class="card-body" style="display: inline-block">
          <span class="h4">Permissions</span>
          <hr />

          <ul class="list-inline" style="display: inline-block">
            <li *ngFor="let resource of role.securedResources">
              &#x25ba;<code> {{ resource.resourceName }}</code> {{ resource.accessList.join(' | ')
              }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="card">
        <div class="card-body">
          <span class="h4">Members</span>
          <hr />
          <ul class="list-inline">
            <li *ngFor="let member of role.subscriptions">
              <person-link [user]="member.displayName"></person-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
